/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Pair } from './pair';

export interface RouteOrder {
  id?: number;
  origId?: number;
  createTime?: string;
  pairId?: number;
  pair?: Pair;
  buy?: boolean;
  quantity?: number;
  price?: number;
  expectedPrice?: number;
  ackReceived?: boolean;
  accountId?: number;
  side?: RouteOrder.SideEnum;
}
export namespace RouteOrder {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
}
